import {getDefaultMarkerIcon, Marker, MarkerIcon, MarkerProps} from "../Marker/Marker";
import {useCallback, useEffect, useMemo, useRef} from "react";
import {OpsLocationStatus} from "../../../../model/ops-status";

export type OpsStatusMarkerProps =
  Omit<MarkerProps, "position" | "icon" | "onHover" | "onHoverOut" | "onMarkerClick" | "label" | "onLoad">
  & {
  ctx: OpsLocationStatus;
  icon?: MarkerIcon | ((ctx: OpsLocationStatus) => MarkerIcon | undefined);
  iconColor?: string | ((ctx: OpsLocationStatus) => string | undefined)
  onHover?: (e: google.maps.MapMouseEvent, ctx: OpsLocationStatus) => void;
  onHoverOut?: (e: google.maps.MapMouseEvent) => void;
  onMarkerClick?: (e: google.maps.MapMouseEvent, ctx: OpsLocationStatus) => void;
};

export const OpsStatusMarker = (props: OpsStatusMarkerProps) => {
  const {
    ctx,
    icon,
    onHover,
    onHoverOut,
    onMarkerClick,
    ...rest
  } = props;

  const markerRef = useRef<google.maps.Marker | null>(null);

  const position: google.maps.LatLngLiteral | undefined = useMemo(() => {
    if (typeof ctx.latCoord !== "undefined" && typeof ctx.longCoord !== "undefined") {
      return {
        lat: ctx.latCoord,
        lng: ctx.longCoord
      }
    }
    return undefined
  }, [ctx.latCoord, ctx.longCoord])

  const markerIcon = useMemo(() => {
    if (icon) {
      if (icon instanceof Function) {
        return icon(ctx);
      } else {
        return icon;
      }
    } else {
      return getDefaultMarkerIcon(ctx.overallColor)
    }
  }, [icon, ctx])


  const onLoad = useCallback((marker: google.maps.Marker) => {
    markerRef.current = marker;
    marker.set("opsStatus", ctx);
  }, [ctx])

  useEffect(() => {
    if (markerRef.current) {
      markerRef.current.setIcon(markerIcon);
    }
  }, [markerIcon])

  if (!position) {
    return null
  }

  return (
    <Marker
      {...rest}
      position={position}
      icon={markerIcon}
      onMouseOver={onHover ? (e) => onHover(e, ctx) : undefined}
      onMouseOut={onHoverOut ? (e) => onHoverOut(e) : undefined}
      onClick={onMarkerClick ? (e) => onMarkerClick(e, ctx) : undefined}
      onLoad={onLoad}
    />
  );
};
